import { Ability } from "ember-can";

export default class CareGiverAbility extends Ability {
  get canEdit(): boolean {
    return true;
  }
}
